import { storageDateFormat, displayDateFormat } from '@/core';
import moment from 'moment';

let updateSearchFilterDate = (state, { key, isFrom, date }) => {
	let dateMoment = moment(date, displayDateFormat).startOf('day');
	if (isFrom) {
		state.searchFilter[key].from = dateMoment.isValid() ? dateMoment.startOf('day').format(storageDateFormat) : '';
	} else {
		state.searchFilter[key].to = dateMoment.isValid() ? dateMoment.endOf('day').format(storageDateFormat) : '';
	}
};

let addSearchFilterTagList = (state, { key, tag }) => {
	let alreadyAdded = state.searchFilter[key].some(x => x.id === tag.id);
	if (alreadyAdded) return;
	state.searchFilter[key].push(tag);
};
let appendSearchFilterTagList = (state, { key, tags }) => {
	for (let tag of tags) {
		let alreadyAdded = state.searchFilter[key].some(x => x.id === tag.id);
		if (alreadyAdded) continue;
		state.searchFilter[key].push(tag);
	}
};
let addSearchFilterValueList = (state, { key, tag }) => {
	let alreadyAdded = state.searchFilter[key].some(x => x === tag);
	if (alreadyAdded) return;
	state.searchFilter[key].push(tag);
};
let setSearchFilterTagList = (state, { key, tagList }) => {
	state.searchFilter[key] = tagList;
};

let setSearchFilterValue = (state, { key, value }) => {
	state.searchFilter[key] = value;
};

let updateSearchFilterTag = (state, { key, tag }) => {
	let index = state.searchFilter[key].findIndex(x => x.id === tag.id);
	if (index === -1) return;
	state.searchFilter[key].splice(index, 1, tag);
};

export default {
	updateSearchFilterDate,
	addSearchFilterTagList,
	appendSearchFilterTagList,
	addSearchFilterValueList,
	setSearchFilterTagList,
	setSearchFilterValue,
	updateSearchFilterTag
};
